import useFirestore from "../common/useFirestore";

function useAccount(uid){
    const {readFirestoreWithQuery} = useFirestore();

    const getCommonUser = async() => {
        const account = await readFirestoreWithQuery("Account", {field:"uid", operator:"==", data:uid}).then(res => {
            if(!res.empty){
                return res.docs[0].data();
            }
            return null;
        })
        return account;
    }
    return {getCommonUser}
}

export default useAccount;